module.exports = __webpack_public_path__ + "img/LATAM_CAKES_AND_PASTRIES.8a57dcc1.png";